
export const errorCheckPrice = ( item ) => {
    switch( item.code ){
        case 'RATE_NOT_FOUND':
            return 'ไม่พบเรทราคา'
        case 'ERROR_MAX_WIDTH':
        case 'ERROR_MAX_LENGTH':
        case 'ERROR_MAX_HEIGHT':
        case 'ERROR_MAX_WLH':
        case 'ERROR_MAX_WEIGHT':
            return item.msg
        default:
            return item.msg
    }
}

// setting line
export const STEP_FIRST = 'FIRST'
export const STEP_SECOND = 'SECOND'
export const STATUS_DISABLED = 0;
export const STATUS_ENABLE = 1;

export const copyText = (text) => {
    navigator.clipboard.writeText(text);
}